module.exports = {
  proxyTarget: process.env.REACT_APP_PROXY_TARGET,
  reportURL: process.env.REACT_APP_REPORT_URL,
  websocketURL: process.env.REACT_APP_WEBSOCKET_URL
};
